export default "__VITE_ASSET__VZd5mCAk__"